<template>
  <div class="content-box-same-person" v-if="show">
    <div class="content bg">
      <img class="img-title" :src="require(`../assets/${targetFolder}/samePerson/same_person_title.png`)" />
      <div class="specific">
        <div class="specific-content">
          <img @click="closeDialog" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" />
          <div class="content-title">
            <img class="checked"
            @click="checked = 1 "
            :src="checked === 1 ? require(`../assets/${targetFolder}/samePerson/checked1.png`) : require(`../assets/${targetFolder}/samePerson/unchecked1.png`)"  />
            <img class="checked"
             @click="checked = 2"
            :src="checked === 2 ? require(`../assets/${targetFolder}/samePerson/checked2.png`) : require(`../assets/${targetFolder}/samePerson/unchecked2.png`)"  />
          </div>
          <template>
             <ul>
              <li v-for="item in list" :key="item.id" @click="openMark(item)">
                <img class='img-content' :src="item.pc" />
              </li>
               <template v-if="list.length > 0">
                <img @click="prev" class="prev" :src="require(`../assets/${targetFolder}/samePerson/prev.png`)" />
                <img @click="next" class="next" :src="require(`../assets/${targetFolder}/samePerson/next.png`)" />
              </template >
            </ul>
          </template>
           <template v-if="list.length > 0">
            <div id="page" class="page-box">
              <div class="pagination">
                <img
                  @click="prev"
                  class="page-prev" :src="require(`../assets/${targetFolder}/samePerson/lt.png`)" />
                <template >
                  <span
                    class="num"
                    :class="{
                      active: item === page.current
                    }"
                    v-for="item in pager"
                    @click="page.current = item"
                    :key="item">{{item}}</span>
                </template>
                <img
                  @click="next"
                  class="page-next" :src="require(`../assets/${targetFolder}/samePerson/gt.png`)" />
              </div>
              <span class="tip">
                共&nbsp;{{totalPage}}&nbsp;页
              </span>
            </div>
          </template>
        </div>
      </div>
      <div class="mark" v-if="markShow" @click="markShow = false"></div>
      <template v-if="markShow">
        <div class="dialog-content-same-person"  @click="markShow = false">
          <!-- <img @click="markShow = false" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" > -->
          <img class="source-material" :src="material" />
          <div class="describe">
            {{describe}}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getWebSiteContent
} from '@/api'
export default {
  name: 'SamePerson',
  data () {
    return {
      show: false,
      markShow: false,
      checked: 1,
      page: {
        total: 16,
        current: 1,
        per_page: window.device.type === 'desktop' ? 4 : 2
      },
      material: '',
      describe: '《这是同人画作标题》',
      list: []
    }
  },
  computed: {
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    },
    totalPage () {
      const total = Math.ceil(this.page.total / this.page.per_page)
      // eslint-disable-next-line no-self-compare
      return total === total ? total : 1
    },
    pager () {
      const current = this.page.current
      const arr = [current]
      const totalPage = this.totalPage
      if (totalPage < 4) {
        const arr = []
        for (let index = 1; index <= totalPage; index++) {
          arr.push(index)
        }
        return arr
      }
      let f = false
      if (current + 3 > totalPage) {
        f = true
        if (current + 1 <= totalPage) {
          arr.push(current + 1)
        }
        if (current + 2 <= totalPage) {
          arr.push(current + 2)
        }
        if (current + 3 <= totalPage) {
          arr.push(current + 3)
        }
      } else {
        if (current - 1 > 0) {
          arr.unshift(current - 1)
        }
        if (current - 2 > 0) {
          arr.unshift(current - 2)
        }
        if (current - 3 > 0) {
          arr.unshift(current - 3)
        }
      }
      const loop = 3 - arr.length
      for (let index = 1; index <= loop; index++) {
        if (f) {
          arr.unshift(current - index)
        } else {
          arr.push(current + index)
        }
      }
      return arr
    }
  },
  watch: {
    'page.current' (v) {
      this.getWebSiteContent()
    },
    'checked' (v) {
      if (v) {
        this.checked = v
        if (this.page.current > 1) {
          this.page.current = 1
        } else {
          this.getWebSiteContent()
        }
      }
    }
  },
  mounted () {

  },
  created () {
    require(`../styles/${this.targetFolder}/sameperson.scss`)
  },
  methods: {
    closeDialog () {
      this.show = false
      this.$emit('closeDialog')
    },
    openMark (item) {
      if (this.checked === 2) {
        location.href = item.url
        // window.open(item.url)
      } else {
        this.describe = item.desc
        this.material = item.pc
        this.markShow = true
      }
    },
    prev () {
      if (this.page.current > 1) {
        this.page.current--
      }
    },
    next () {
      if (this.page.current < this.totalPage) {
        this.page.current++
      }
    },
    // 新版官网获取数据
    async getWebSiteContent (value) {
      try {
        const params = {
          type: 3,
          per_page: this.page.per_page,
          mtype: this.checked,
          page: this.page.current
        }
        const { data } = await getWebSiteContent(params)
        this.page.total = data.total
        this.list = data.data
        // this.isLoading = true
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
